import React from 'react';
import CodeSnippet from './CodeSnippet';
import {
  DocContainer,
  Title,
  SubTitle,
  Paragraph,
  List,
  ListItem,
  Code,
} from './DocStyles';

const Nginx: React.FC = () => {
  return (
    <DocContainer>
      <Title>Configuração do Nginx</Title>
      <Paragraph>
        Para configurar o Nginx corretamente em um ambiente Docker, siga os
        passos abaixo:
      </Paragraph>

      <SubTitle>1. Acessando o Container</SubTitle>
      <Paragraph>
        Primeiro, precisamos acessar o bash do container do Nginx. Use o
        seguinte comando:
      </Paragraph>
      <CodeSnippet code="docker exec -it <nome-container> bash" />
      <Paragraph>
        Substitua <Code>&lt;nome-container&gt;</Code> pelo nome real do seu
        container Nginx.
      </Paragraph>

      <SubTitle>2. Configurando o Nginx</SubTitle>
      <Paragraph>
        Dentro do container, você precisará editar o arquivo de configuração
        principal do Nginx:
      </Paragraph>
      <CodeSnippet code="vi /etc/nginx/nginx.conf" />

      <Paragraph>
        Localize o bloco <Code>location</Code> dentro da configuração do
        servidor e modifique-o para:
      </Paragraph>
      <CodeSnippet
        code={`location / {
    root /var/www/html;
    try_files $uri $uri/ /index.html;
}`}
      />

      <SubTitle>Explicação da Configuração</SubTitle>
      <List>
        <ListItem>
          <strong>root /var/www/html</strong>: Define o diretório raiz onde
          estão os arquivos da aplicação
        </ListItem>
        <ListItem>
          <strong>try_files $uri $uri/ /index.html</strong>: Configura o
          fallback para o index.html, necessário para aplicações React com
          roteamento client-side
        </ListItem>
      </List>

      <SubTitle>Nota para Ambiente de Produção</SubTitle>
      <Paragraph>
        Em ambiente de produção, dependendo da estrutura do seu projeto, pode
        ser necessário ajustar o diretório raiz para:
      </Paragraph>
      <CodeSnippet
        code={`location / {
    root /var/www/html/public;
    try_files $uri $uri/ /index.html;
}`}
      />
      <Paragraph>
        Isso ocorre porque alguns servidores de produção podem ter uma estrutura
        de diretórios diferente, onde os arquivos estáticos são servidos a
        partir da pasta 'public'.
      </Paragraph>

      <SubTitle>3. Aplicando as Alterações</SubTitle>
      <Paragraph>
        Após fazer as alterações, você precisa reiniciar o Nginx para
        aplicá-las:
      </Paragraph>
      <CodeSnippet code="nginx -s reload" />

      <Paragraph>
        Ou você pode reiniciar o container do Docker com o comando:
      </Paragraph>
      <CodeSnippet code="docker restart <nome-container>" />
      <Paragraph>
        Substitua <Code>&lt;nome-container&gt;</Code> pelo nome real do seu
        container Docker.
      </Paragraph>

      <Paragraph>
        Esta configuração permite que sua aplicação React funcione corretamente
        com rotas client-side, redirecionando todas as requisições para o
        index.html e deixando o React Router cuidar da navegação.
      </Paragraph>
    </DocContainer>
  );
};

export default Nginx;
